import { useEffect, useState } from 'react';
import cls from 'classnames';

import getBreadcrumbSublinks from '../../../utils/breadcrumbSubLinks';

import useStyles from './styles';
import Breadcrumb from './Breadcrumb';
import { IBreadcrumb, IWithLocationBreadcrumb } from './types';

const homeItem: IBreadcrumb = {
  text: 'Home',
  href: '/',
};
function WithLocationBreadcrumb({
  whiteText = false,
  withLayoutBackground = true,
}: IWithLocationBreadcrumb) {
  const classes = useStyles({ whiteText, withLayoutBackground });
  const [itemsToDysplay, setItemsToDisplay] = useState<IBreadcrumb[]>([]);

  useEffect(() => {
    if (window?.location?.pathname) {
      const paths = getBreadcrumbSublinks(window.location.pathname);
      const links = paths.map((path) => {
        return { href: `${window.location.origin}${path.href}`, text: path.text };
      });
      setItemsToDisplay([homeItem, ...links]);
    }
  }, [window?.location?.pathname]);

  return (
    <>
      {itemsToDysplay.length > 1 && (
        <div className={cls(classes.root)}>
          <div className={classes.container}>
            <Breadcrumb items={itemsToDysplay} whiteText={whiteText} />
          </div>
        </div>
      )}
    </>
  );
}
export default WithLocationBreadcrumb;
